export default function menuspyInit() {
	if (!$("#site-sticky-nav-list").length) return;
	var elm = document.querySelector('#site-sticky-nav-list');
	var ms = new MenuSpy(elm, {
		activeClass: 'active',
		menuItemSelector: 'a',
		enableLocationHash: false,
		hashTimeout: 600,
		threshold: 128,
	});
}

document.addEventListener("scroll", function(e) {
	if (window.innerWidth < 768 && $('#site-sticky-nav-list').length > 0) {
		setTimeout(function() {
			var nav = $('#site-sticky-nav-list');
			var activeLi = nav.find('li.active');
			if (activeLi.length > 0) {
				nav.scrollLeft(activeLi[0].offsetLeft - 20);
			}
		}, 0);
	}
}, true);
